import React, { useState } from 'react';
import styled from 'styled-components';

import { Helmet } from 'react-helmet';
import { useNavigate, Link } from 'react-router-dom';

import { auth } from './../firebase/firebaseConfig';

import {
	signInWithEmailAndPassword,
	sendPasswordResetEmail,
	GoogleAuthProvider,
	signInWithPopup
} from "firebase/auth";

import { ReactComponent as SvgLogin } from './../imagenes/login.svg';

const Pantalla = styled.div`
	width: 100%;
	min-height: 100vh;

	display: flex;
	justify-content: center;
	align-items: center;

	padding: 24px;
`;

const Card = styled.div`
	width: 100%;
	max-width: 430px;

	background: rgba(255,255,255,0.96);

	border-radius: 32px;

	padding: 42px 32px;

	box-shadow:
		0 20px 40px rgba(0,0,0,.12);

	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Logo = styled(SvgLogin)`
	width: 140px;
	height: auto;

	margin-bottom: 28px;
`;

const Titulo = styled.h1`
	font-size: 2.5rem;
	font-weight: 700;

	text-align: center;

	margin-bottom: 32px;

	color: #111;
`;

const Input = styled.input`
	width: 100%;
	height: 58px;

	border: none;
	border-radius: 16px;

	padding: 0 18px;

	margin-bottom: 16px;

	background: #F1F3FA;

	font-size: 16px;

	outline: none;
`;

const Recuperar = styled.p`
	width: 100%;

	text-align: right;

	font-size: 14px;

	color: #5B69E2;

	cursor: pointer;

	margin-bottom: 22px;
`;

const Boton = styled.button`
	width: 100%;
	height: 58px;

	border: none;
	border-radius: 16px;

	background: ${props => props.google ? '#000' : '#5B69E2'};

	color: white;

	font-size: 18px;
	font-weight: 700;

	cursor: pointer;

	margin-bottom: 14px;

	transition: .2s ease all;

	&:hover{
		transform: translateY(-2px);
	}
`;

const TextoRegistro = styled.p`
	margin-top: 12px;

	font-size: 14px;

	color: #555;

	a{
		color: #5B69E2;
		font-weight: 700;
		text-decoration: none;
	}
`;

const InicioSesion = () => {

	const navigate = useNavigate();

	const [correo, establecerCorreo] = useState('');
	const [password, establecerPassword] = useState('');

	// LOGIN NORMAL
	const handleSubmit = async () => {

		if(!correo || !password){
			alert('Completa todos los campos');
			return;
		}

		try{
			await signInWithEmailAndPassword(auth, correo, password);
			navigate('/');
		}catch(error){
			alert('Error al iniciar sesión');
		}
	};

	// GOOGLE LOGIN
	const handleGoogleLogin = async () => {

		const provider =
			new GoogleAuthProvider();
	
		try {
	
			const resultado =
				await signInWithPopup(
					auth,
					provider
				);
	
			console.log(
				"GOOGLE LOGIN OK",
				resultado.user.uid
			);
	
			setTimeout(() => {
	
				navigate("/");
	
			}, 1000);
	
		} catch(error) {
	
			console.error(error);
	
			alert(
				"Error con Google"
			);
		}
	};

	// RECUPERAR PASSWORD
	const handleResetPassword = async () => {

		if(!correo){
			alert('Ingresa tu correo');
			return;
		}

		try{
			await sendPasswordResetEmail(auth, correo);
			alert('Correo enviado');
		}catch(error){
			alert('Error enviando correo');
		}
	};

	return (
		<>
			<Helmet>
				<title>Iniciar Sesión</title>
			</Helmet>

			<Pantalla>

				<Card>

					<Logo />

					<Titulo>
						🚀 Bienvenido
					</Titulo>

					<Input
						type="email"
						placeholder="Correo Electrónico"
						value={correo}
						onChange={(e) => establecerCorreo(e.target.value)}
					/>

					<Input
						type="password"
						placeholder="Contraseña"
						value={password}
						onChange={(e) => establecerPassword(e.target.value)}
					/>

					<Recuperar onClick={handleResetPassword}>
						¿Olvidaste tu contraseña?
					</Recuperar>

					<Boton onClick={handleSubmit}>
						Iniciar Sesión
					</Boton>

					<Boton
						google
						onClick={handleGoogleLogin}
					>
						Iniciar con Google
					</Boton>

					<TextoRegistro>
						¿No tienes cuenta?{' '}
						<Link to="/crear-cuenta">
							Regístrate
						</Link>
					</TextoRegistro>

				</Card>

			</Pantalla>
		</>
	);
}

export default InicioSesion;